import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import GameCanva from '../../components/TechGame/GameCanva/GameCanva';
import Leaderboard from '../../components/TechGame/Leaderboard/Leaderboard';
import GameHome from '../../components/TechGame/GameHome/GameHome';
import './TechGame.css';
import VideoPresentationInformatique from './techgame.mp4'; 
import VideoPresentationInformatiquePoster from './techgameposter.png'; 

function TechGame() {
  const [gameState, setGameState] = useState('HOME'); // HOME, PLAYING, GAMEOVER
  const [finalScore, setFinalScore] = useState(0);
  const location = useLocation();

  // Reset automatique vers la page d'accueil du jeu lors de la navigation
  useEffect(() => {
    setGameState('HOME');
    setFinalScore(0);
  }, [location.key]);

  const handleGameOver = (score) => {
    setFinalScore(score);
    setGameState('GAMEOVER');
  };

  const handleRestart = () => {
    setGameState('PLAYING');
    setFinalScore(0);
  };

  const handleGoHome = () => {
    setGameState('HOME');
    setFinalScore(0);
  };

  const handleStartGame = () => {
    setGameState('PLAYING');
    document.getElementById('game-content-start').scrollIntoView({ behavior: 'smooth' })
  };

  return (
    <>
      {/* 1. HERO COMPACT ET DESIGN SANS RÉPÉTITION (100VH) */}
      <div className="game-hero-container">
        <div className="game-video-wrapper">
          <video 
            src={VideoPresentationInformatique} 
            autoPlay 
            muted 
            loop 
            playsInline 
            className="game-background-video" 
            aria-label="Animation vidéo d'ambiance du jeu"
          />
          <div className="game-hero-overlay"></div>
        </div>

        <div className="game-hero-center-text">
          <span className="game-tag">Jeu officiel de AM Services</span>
          <h1 className="game-hero-title">TECH RUNNER</h1>
          <div className="game-title-divider"></div>
          
          {/* BOUTON INTÉGRÉ DANS LE HERO - RESPECTE LA CHARTE GLASS */}
          {gameState === 'HOME' && (
            <button className="btn-game-hero-launch" onClick={() => document.getElementById('rules-game').scrollIntoView({ behavior: 'smooth' })}>
              VOIR LES REGLES
            </button>
          )}
        </div>

        <div className="scroll-indicator" onClick={() => document.getElementById('game-content-start').scrollIntoView({ behavior: 'smooth' })}>
          <span className="arrow"></span>
        </div>
      </div>

      {/* 2. ZONE DE JEU PRINCIPALE SUR FOND BLANC PROPRE */}
      <div className="app-layout" >
        <main className="main-content" id='game-content-start'>
          {gameState === 'HOME' && (
            <div className="game-home-wrapper "id="rules-game">
              <GameHome onStartGame={handleStartGame} />
              
              {/* BOUTON EN BAS DES RÈGLES COHÉRENT AVEC LA CHARTE CYBER */}
              <div className="game-rules-cta-zone">
                <button className="btn-game-rules-start" onClick={handleStartGame}>
                  J'ai compris, jouer !
                </button>
              </div>
            </div>
          )}

          {gameState === 'PLAYING' && (
            <div className="game-zone">
              <div className="game-header">
                <h2>Partie en cours</h2>
              </div>
              <GameCanva onGameOver={handleGameOver} />
            </div>
          )}

          {gameState === 'GAMEOVER' && (
            <Leaderboard 
              score={finalScore} 
              onRestart={handleRestart} 
              onGoHome={handleGoHome}
            />
          )}
        </main>
      </div>
    </>
  );
}

export default TechGame;